import { AnyAction } from 'redux';
import { LOGOUT_SUCCESS, VERIFY_LOGIN_OTP_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS } from '../types/application';

export type ParamsProps = {
  page: number;
  search: string;
  applicationType: string;
  status: string;
  modeOfHolding: string;
  distributorId: string;
  applicationSentBack: boolean | null;
  diy?: string;
  accountType?: string;
  onboardingType?: string;
  bseClientActivationStatus?: string;
  rekycStatus?: string;
  reKycReason?: string;
};

export const initialState: ParamsProps = {
  page: 1,
  applicationType: '',
  status: '',
  search: '',
  modeOfHolding: '',
  distributorId: '',
  diy: '',
  accountType: '',
  onboardingType: "",
  bseClientActivationStatus: '',
  applicationSentBack: null,
  reKycReason: '',
  rekycStatus: ''

};

function paramsReducer(state = initialState, action: AnyAction): Partial<ParamsProps> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        status:
          action?.body?.role === 'amcapprover'
            ? 'sent_to_amc_approver'
            : action?.body?.role === 'poaapprover'
              ? 'sent_to_poa_approver'
              : '',
      };
    }
    case 'GET_PARAMS_DATA':
      return {
        ...state,
        page: action.paramsObj.page,
        applicationType: action.paramsObj.applicationType,
        status: action.paramsObj.status,
        modeOfHolding: action.paramsObj.modeOfHolding,
        distributorId: action.paramsObj.distributorId,
        search: action.paramsObj.search,
        diy: action.paramsObj.diy,
        accountType: action.paramsObj.accountType,
        onboardingType: action.paramsObj.onboardingType,
        bseClientActivationStatus: action.paramsObj.bseClientActivationStatus,
        applicationSentBack: action.paramsObj.applicationSentBack,
        reKycReason: action.paramsObj.reKycReason,
        rekycStatus: action.paramsObj.rekycStatus
      };
    case CREATE_APPLICATION_SUCCESS:
    case LOGOUT_SUCCESS: {
      return { ...initialState };
    }
    default:
      return state;
  }
}

export default paramsReducer;
